(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let shell;
  let hero;
  let ticking = false;

  const mount = () => {
    hero = document.querySelector('.template-index [data-home-hero]');
    shell = hero && hero.closest('.shopify-section');
    if (!hero || !shell) return false;
    shell.classList.add('wr-hero-scroll-shell');
    return true;
  };

  const update = () => {
    ticking = false;
    if ((!hero || !hero.isConnected) && !mount()) return;

    if (reduced) {
      hero.style.removeProperty('--wr-hero-inset-x');
      hero.style.removeProperty('--wr-hero-inset-bottom');
      hero.style.removeProperty('--wr-hero-transition-radius');
      hero.style.removeProperty('--wr-hero-media-scale');
      return;
    }

    const viewport = Math.max(1, window.innerHeight);
    const progress = clamp(-shell.getBoundingClientRect().top / (viewport * 0.72), 0, 1);
    const mobile = window.innerWidth < 750;
    const eased = 1 - Math.pow(1 - progress, 3);
    const insetX = eased * (mobile ? 14 : 50);
    const insetBottom = eased * (mobile ? 16 : 38);

    hero.style.setProperty('--wr-hero-inset-x', `${insetX.toFixed(2)}px`);
    hero.style.setProperty('--wr-hero-inset-bottom', `${insetBottom.toFixed(2)}px`);
    hero.style.setProperty('--wr-hero-transition-radius', `${(12 + eased * 8).toFixed(2)}px`);
    hero.style.setProperty('--wr-hero-media-scale', (1 + eased * 0.035).toFixed(4));
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const refresh = () => {
    shell = null;
    hero = null;
    mount();
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  mount();
  update();
})();
